import React from "react";
import { Popover } from "antd";
import HelpIcon from "../../assets/icons/help.svg?react";
import { ROLES, RoleConfig } from "./rolesConfig";

export default function HelpPopover() {
  const content = (
    <div className="text-[#2B4752] text-sm">
      <div className="mt-3 flex flex-col border-b pb-2 first:mt-0">
        <p className="font-semibold">
          Use this page to assign study access and roles for invited users.
        </p>
        <p>
          Invite or remove people in Users &amp; Access. Admins can manage
          people and permissions, but they do not get study data access by
          default.
        </p>
        <p className="mt-2 font-semibold">
          All roles have access to Ask Vivo, Insights, and Alerts.
        </p>
        <p className="font-semibold">
          The following roles have the following permissions*
        </p>
        <p className="text-xs text-[#00000073]">
          *Users can have more than one role.
        </p>
      </div>
      {Object.values(ROLES).map((role, index, arr) => (
        <div
          key={role.name}
          className={
            index < arr.length - 1 ? "border-b pb-2 mt-3 first:mt-0" : "mt-3"
          }
        >
          <div
            className="mb-1 text-white text-xs rounded-sm gap-[10px] py-[2px] px-[4px] justify-self-start w-fit"
            style={{ backgroundColor: role.color }}
          >
            {role.name}
          </div>
          {role.description.map((desc, i) => (
            <p
              key={i}
              className={
                i > 0 ? ((role as unknown as RoleConfig).noteClass ?? "") : ""
              }
            >
              {desc}
            </p>
          ))}
        </div>
      ))}
    </div>
  );

  return (
    <Popover content={content} placement="bottomLeft" arrow={false}>
      <span>
        {" "}
        {/*Added to avoid findDOMNode warning until antd decides to fix this warning*/}
        <HelpIcon />
      </span>
    </Popover>
  );
}
